import { isAnyOverlayFormVisible } from './form';
import { isMobileOs } from './browser';
import { queueESEvents, ESEventTypes } from './logEventToElasticSearch';

export const REMOTE_CALLER_ADD_SOUND_PATH = window.APP.EXTERNAL_LINKS.WaitingArea.CallerJoinedAudioLink;

export const notifyNewCallerInWaitingArea = (pubnubMessage) => {
  console.log('notifyNewCallerInWaitingArea called, alert this logged in provider', pubnubMessage);

  if (window.getState().usersReducer.isInCall) {
    console.log('Current user is already in a call, so skip new call alert');
    return;
  }

  // wait between 0 and 500 milliseconds to allow only 1 tab of multiple tabs to show/play the notification
  let randomWaitMs = Math.floor(Math.random() * 500);

  setTimeout(() => {
    // if this message has already been dispalyed by another tab, then don't show same message again
    let localStorageKeyForAlertMessage = 'WAITING_AREA_NEW_CALLER_JOINED' + pubnubMessage.networkId;
    let messageUniqueId = pubnubMessage.messageUniqueId;
    if (window.localStorage.getItem(localStorageKeyForAlertMessage) === messageUniqueId) {
      console.warn(
        'This message has already been dispalyed by another tab, so not showing again',
        window.localStorage.getItem(localStorageKeyForAlertMessage),
        messageUniqueId
      );
      return;
    }

    console.info('This message has not been dispalyed yet by another tab, so showing the message from this tab');
    window.localStorage.setItem(localStorageKeyForAlertMessage, messageUniqueId);

    showDesktopAlert(pubnubMessage);
    playAudioAlert(REMOTE_CALLER_ADD_SOUND_PATH);
  }, randomWaitMs);
};

export const playAudioAlert = (audioFilePath, mute = false) => {
  try {
    const audioFileFullPath = audioFilePath;
    var audio = document.getElementById('soundNotification');
    audio.src = audioFileFullPath;
    audio.muted = mute;
    audio.play();
  } catch (err) {
    console.error('Failed to play audio file', err);
    queueESEvents(ESEventTypes.FailToPlayAudio, err.toString());
  }
};

function showDesktopAlert(pubnubMessage) {
  if (!('Notification' in window) || isMobileOs()) {
    console.warn('HTML5 Web Notification API is not available in this browser');
    queueESEvents(ESEventTypes.NotificationAPIUnavailableToShowAlert, false, 'eventType');
    return;
  }

  if (Notification.permission === 'granted') {
    let networkId = pubnubMessage.networkId;
    let notificationTitle = 'People in Waiting Areas';
    let notificationMessage = pubnubMessage.message;
    let dismissInMilliseconds = pubnubMessage.dismissHtml5NotificationInMilliseconds;
    let imageForNewcallerNotification =
      window.APP.CONFIGURATION.CURRENT_VCC_PAGE + pubnubMessage.imageForNewCallerNotification;
    let targetPageUrl = `${window.APP.CONFIGURATION.CURRENT_VCC_PAGE}waiting-area/view-one/${networkId}`;
    let messageUniqueId = pubnubMessage.messageUniqueId;
    console.log('New caller notification message: ' + notificationMessage);
    let notification = new Notification(notificationTitle, {
      body: notificationMessage,
      icon: imageForNewcallerNotification,
      tag: messageUniqueId,
    });

    queueESEvents(ESEventTypes.NewCallerNotificationShown, true, 'eventType');

    let dismissNotification = function () {
      notification.close();
    };

    notification.onclick = function () {
      // replace the current tab which has gotten the message.
      // instead of opening a new one and closing existing one.
      dismissNotification();
      window.focus();

      console.log('is any overlay form visible', isAnyOverlayFormVisible());
      if (window.location.href === targetPageUrl && isAnyOverlayFormVisible()) {
        // User is already on target page and but an overlay popup is displayed
        // so reload current page
        window.location.reload();
      } else if (window.location.href !== targetPageUrl) {
        // User is no on target page
        // so redirect to target page
        window.location.href = targetPageUrl;
      } else {
        // User is already on target page and no overlay popup displayed
        // so no action required here
      }
    };

    // Auto hide the visual notification after X seconds if user does not intereact
    window.setTimeout(dismissNotification, dismissInMilliseconds);
  } else {
    console.log('Web Notification not shown because permission not granted by user');
    queueESEvents(ESEventTypes.NotificationNotShown, 'permission not granted by user', 'eventType');
  }
}

export function requestPermissionForDesktopAlerts() {
  if (!('Notification' in window) || isMobileOs()) {
    console.warn('HTML5 Web Notification API is not available in this browser');
    queueESEvents(ESEventTypes.NotificationAPIUnavailableToRequestPermit, false, 'eventType');
    return;
  }

  switch (Notification.permission) {
    case 'default':
      console.log('Requesting Web Notifications permission from user...');
      Notification.requestPermission().then(function (result) {
        console.log(result);
      });
      break;

    case 'granted':
      console.log('User has already allowed Web Notifications');
      break;

    case 'denied':
      console.warn('User blocked Web Notifications');
      queueESEvents(ESEventTypes.UserBlockNotification, true, 'eventType');
      break;

    default:
      console.warn('Unkown status for Web Notifications user permission', Notification.permission);
      queueESEvents(ESEventTypes.UnknownStatusForNotificationPermit, true, 'eventType');
  }
}
